export const INSURANCE_DEFAULT_ID = 'heroinsurance.jpg'

export const fallbackInsuranceColors = {
  DEFAULT: '#E5F2F2',
  ['kaiser-permanente']: '#DFF1FB',
  ['molina-healthcare']: '#D9EFF0',
  medicaid: '#DFE6F7',
  medicare: '#DFE6F7',
  optum: '#FEE7E1',
  oscar: '#DFE8FC',
  tricare: '#D7E5F2',
  ['united-healthcare']: '#DCE6F9'
}

export const insuranceLayout: Record<string, { style: string; color: string }> =
  {
    aetna: {
      style: 'bg-insurance-bg-aetna md:border-insurance-bg-aetna',
      color: '#F0E6F4'
    },
    ambetter: {
      style: 'bg-insurance-bg-ambetter md:border-insurance-bg-ambetter',
      color: '#F6E4EF'
    },
    amerihealth: {
      style: 'bg-insurance-bg-amerihealth md:border-insurance-bg-amerihealth',
      color: '#ffffff50'
    },
    anthem: {
      style: 'bg-insurance-bg-anthem md:border-insurance-bg-anthem',
      color: '#DCEFF9'
    },
    'bluecross-blueshield': {
      style:
        'bg-insurance-bg-bluecross-blueshield md:border-insurance-bg-bluecross-blueshield',
      color: '#E0EEF5'
    },
    'bright-health': {
      style:
        'bg-insurance-bg-bright-healthcare md:border-insurance-bg-bright-healthcare',
      color: '#E3EBFC'
    },
    cigna: {
      style: 'bg-insurance-bg-cigna md:border-insurance-bg-cigna',
      color: '#dfe5f9'
    },
    'carelon-behavioral-health': {
      style:
        'bg-insurance-bg-carelon-behavioral-health md:border-insurance-bg-carelon-behavioral-health',
      color: '#E5F5F4'
    },
    compsych: {
      style: 'bg-insurance-bg-compsych md:border-insurance-bg-compsych',
      color: '#E9F0FA'
    },
    default: {
      style: 'bg-insurance-bg-default md:border-insurance-bg-default',
      color: '#f0e6f4'
    },
    healthnet: {
      style: 'bg-insurance-bg-healthnet md:border-insurance-bg-healthnet',
      color: '#E7F3D8'
    },
    geha: {
      style: 'bg-insurance-bg-geha md:border-insurance-bg-geha',
      color: '#F0E6F4'
    },
    humana: {
      style: 'bg-insurance-bg-humana md:border-insurance-bg-humana',
      color: '#E7F3D8'
    },
    'itu-funds': {
      style: 'bg-insurance-bg-itu-funds md:border-insurance-bg-itu-funds',
      color: '#E2E9EA'
    },
    'intermountain-healthcare': {
      style:
        'bg-insurance-bg-intermountain-healthcare md:border-insurance-bg-intermountain-healthcare',
      color: '#DFE6F7'
    },
    'kaiser-permanente': {
      style:
        'bg-insurance-bg-kaiser-permanente md:border-insurance-bg-kaiser-permanente',
      color: '#DFF1FB'
    },
    'molina-healthcare': {
      style:
        'bg-insurance-bg-molina-healthcare md:border-insurance-bg-molina-healthcare',
      color: '#D9EFF0'
    },
    medicaid: {
      style: 'bg-insurance-bg-medicaid md:border-insurance-bg-medicaid',
      color: '#DFE6F7'
    },
    medicare: {
      style: 'bg-insurance-bg-medicare md:border-insurance-bg-medicare',
      color: '#DFE6F7'
    },
    optum: {
      style: 'bg-insurance-bg-optum md:border-insurance-bg-optum',
      color: '#FEE7E1'
    },
    oscar: {
      style: 'bg-insurance-bg-oscar md:border-insurance-bg-oscar',
      color: '#DFE8FC'
    },
    tricare: {
      style: 'bg-insurance-bg-tricare md:border-insurance-bg-tricare',
      color: '#D7E5F2'
    },
    triwest: {
      style: 'bg-insurance-bg-triwest md:border-insurance-bg-triwest',
      color: '#D7DFEA'
    },
    'united-healthcare': {
      style:
        'bg-insurance-bg-united-healthcare md:border-insurance-bg-united-healthcare',
      color: '#DCE6F9'
    }
  }

export const getInsuranceStyle = (slug: string): string => {
  const insurance = insuranceLayout[slug]
  return insurance ? insurance.style : insuranceLayout.default.style
}
